import { cn } from "@/lib/utils";

type BadgeVariant = "default" | "success" | "warning" | "danger" | "primary" | "muted" | "info";

type StatusBadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: "sm" | "md";
};

const styles: Record<BadgeVariant, string> = {
  default: "bg-muted text-slate-400",
  success: "bg-success/10 text-success",
  warning: "bg-warning/10 text-warning",
  danger: "bg-danger/10 text-danger",
  primary: "bg-primary/10 text-primary",
  muted: "bg-muted/60 text-slate-400",
  // Comportamento preservado: "info" nunca teve cor dedicada (caía no estilo base).
  info: "",
};

export function StatusBadge({ children, variant = "default", size = "sm" }: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full font-semibold",
        size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]",
        styles[variant]
      )}
    >
      {children}
    </span>
  );
}
